export const whyData = {
  badge: "WHY US",
  headline: "Why Choose ASCENCIO Group?",
  description:
    "We specialize in one thing — helping aesthetic clinics grow. ASCENCIO Group specializes in marketing for aesthetic clinics in the UK & Ireland, combining SEO, paid ads, automation, and our fully trained appointment setters to attract high-quality patients and keep them coming back.",
  stats: [
    {
      number: "5.0★",
      label: "Stars On Google",
    },
    {
      number: "100%",
      label: "Client Satisfaction",
    },
  ],
  ctaButton: {
    text: "See How It Works",
    link: "/how-it-works",
  },
  image:
    "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80",
};
